import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useUpdateCaseReport(sessionId: string, reportId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { content: string }) =>
      sessionsService.updateCaseReport(sessionId, reportId, input),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports', sessionId),
      });
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports-meta', sessionId),
      });
      // Drawer renders from the clinical bundle — refresh so edits show live.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
